/*
 * @Description: 
 * @Author: 白松博
 * @Date: 2025-03-29 10:47:55
 * @LastEditTime: 2025-03-29 11:14:33
 */
import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

/**
 * 小组资源人员配置Api
 */
export class ProjectResourceApplicationuserApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'project-resource-applicationuser'
  }

}